import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';

class PrivacyPage extends React.Component{
  render(){
    return (
      <FullPage withContainer>
        <h1>Privacy Policy</h1>
        <div className={css.privacy}>
            <h3>Gathering and Use of Information</h3>
            <b>{process.env.REACT_APP_NAME}</b> will only collect your personal information when you voluntuarily register an user account. Information collected from you will never be sold, rented, or shared with third-parties.

            <h3>Cookies</h3>
            The <b>{process.env.REACT_APP_NAME}</b> website utilizes "cookies". A "cookie" is a small text file that permits us to recognize your browser in order to customize your experience, or permit you to access restricted areas. Our cookies do not contain personal information.

            <h3>IP Address</h3>
            Your Internet Protocol ("IP") address is usually associated with the place from which you enter the Internet, like your Internet Service Provider. We use your IP address only to guess your current timezone, that you can at anytime change in your settings page.

            <h3>Mailing Lists</h3>
            We are not going to send you any email newsletter. The only emails that you will receive from <b>{process.env.REACT_APP_NAME}</b> will be reports of your account's performance (that you can always disable in your settings page) and/or notifications about your subscription (if you have one) or your Instagram Accounts.

            <h3>Personal Data We Collect</h3>
            When you sign-up for an account we will collect your Name and Email Address. If you connect your facebook account, we will also collect your current Avatar and update it whenever your change it on Facebook.<br/>
            Every time you manually add a new Instagram Business Account to <b>Stori</b>, we will begin to store these data:
            <ul>
              <li>The name, the Avatar, the bio and the username of the account;</li>
              <li>The count of your followers, following accounts;</li>
              <li>All your Instagram Stories's data, like the media and performance insights.</li>
            </ul>
            All these data are saved to provide you a better experience on distinguish your account on <b>{process.env.REACT_APP_NAME}</b> and to create better statistics for you. All the data that are collecting are then showed to you in the Stori website. We will never sold, rent or share this data with anyone.<br/>
            We do not store your credit card information.That is sent to and stored at our credit card merchant provider: Stripe.

            <h3>Third party data collectors</h3>
            To help us deliver to you the best Instagram Stories performance tool, we use this third party services:
            <ul>
            <li>Stripe, to handle in the best way possible all the payments. <small>(<a href="https://stripe.com/it/privacy">Privacy Policy</a>)</small></li>
            <li>Google Analytics, to know which pages are more used by the users and to know how many people are visiting Stori everyday. <small>(<a href="https://policies.google.com/privacy">Privacy Policy</a>)</small></li>
            <li>Google Adwords, to show ads on free accounts. <small>(<a href="https://policies.google.com/privacy">Privacy Policy</a>)</small>;</li>
            </ul>

            <h3>Personal Data Removal</h3>
            You are free to remove all the personal information <b>{process.env.REACT_APP_NAME}</b> gathered from you, when you voluntarily signed-up for an account, at any time by cancelling your <b>{process.env.REACT_APP_NAME}</b> account. Also, all accounts and stories (including media and insights) associated to that account will be deleted in the next 24 hours.

            <h3>Commitment</h3>
            <b>{process.env.REACT_APP_NAME}</b> is committed to privacy and support industry initiatives to preserve individual privacy rights on the Internet.<br/>
            We tried to keep this privacy policy as simple as possible: if you have any doubts please contact us at {process.env.REACT_APP_CONTACT_EMAIL}.
            <br/>
            <br/>
            <br/>
            <br/>
            
        </div>
      </FullPage>
    )
  }
}

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/components/privacy/index.js